import * as ReduxUtils from "../../lib/util/ReduxUtils";
import * as FleetActions from "./Fleet.action";
import * as StorageUtils from "../../lib/util/StorageUtils";
import { FLEETS_KEY } from "../../StorageKeys";
import { Fleet } from "../../lib/types/Fleet";
import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

export interface FleetReducerState {
	scopeFleet: AsyncState<Fleet | null>;
	allFleets: AsyncState<Fleet[]>;
}

const initialState: FleetReducerState = {
	scopeFleet: AsyncState.create<Fleet | null>(null),
	allFleets: AsyncState.create([]),
};

export default ReduxUtils.composeReducer(
	initialState,
	(initialState) => ({
		...initialState,
		allFleets: AsyncState.resolve(
			AsyncState.create([]),
			StorageUtils.get(FLEETS_KEY) || [],
		),
	}),
	[
		createAsyncStateReducer<FleetReducerState>({
			allFleets: FleetActions.getAllFleets.type,
			scopeFleet: FleetActions.getScopeFleet.type,
		}),
	],
);
